import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { SecurityClassificationDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-security-classification-container',
  templateUrl: './security-classification-container.component.html',
  styleUrls: ['./security-classification-container.component.scss']
})
export class SecurityClassificationContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  securityclassifications$: Observable<SecurityClassificationDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("SecurityClassification");
    this.securityclassifications$ = this.gatwayFacade.loadGateway("SecurityClassification");
    this.securityclassifications$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteSecurityClassification(deletedValue: any) {
    this.gatwayFacade.remove("SecurityClassification", deletedValue);
    // this.store.dispatch(SecurityClassificationStoreActions.removeSecurityClassification({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitSecurityClassification(formValue: any) {
    console.log("form value: ", formValue);
    formValue.SecurityClassifications = formValue.SecurityClassifications.reverse();
    event.preventDefault();
    const pullData = formValue.SecurityClassifications;
    //const newPullData = formValue.SecurityClassificationes;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllSecurityClassification = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllSecurityClassification.push(pullData[i]);
    }
  }

// check if the addAllSecurityClassification array is not empty, then dispatch the data to the store
   if(addAllSecurityClassification.length !== 0) {
    this.gatwayFacade.add('SecurityClassification', addAllSecurityClassification);
    // this.store.dispatch(SecurityClassificationStoreActions.addSecurityClassification({newSecurityClassification: addAllSecurityClassification}));

   }

// dispatch update data to the store
this.gatwayFacade.update('SecurityClassification', allUpdates, ['id']);
    // this.store.dispatch(SecurityClassificationStoreActions.updateSecurityClassification({updateSecurityClassification: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}
